import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PublicNavbar from '../../components/public/PublicNavbar';
import PublicFooter from '../../components/public/PublicFooter';
import { API } from '../../contexts/AuthContext';
import { Search, X, Download, ExternalLink, ChevronRight, Play, Calendar, Image } from 'lucide-react';
import SEOHead from '../../components/SEOHead';

const BACKEND = API.replace('/api', '');
const resolveUrl = (u) => u?.startsWith('/api') ? `${BACKEND}${u}` : u;

const MONTHS = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
const FULL_MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

const CAT_THEME = {
  company:      { bg: '#0c3c60', light: '#e8f4fd', text: '#0c3c60' },
  product:      { bg: '#059669', light: '#ecfdf5', text: '#059669' },
  innovation:   { bg: '#2563eb', light: '#eff6ff', text: '#2563eb' },
  event:        { bg: '#7c3aed', light: '#f5f3ff', text: '#7c3aed' },
  achievement:  { bg: '#d97706', light: '#fffbeb', text: '#d97706' },
  publication:  { bg: '#0891b2', light: '#ecfeff', text: '#0891b2' },
  partnership:  { bg: '#0d9488', light: '#f0fdfa', text: '#0d9488' },
  announcement: { bg: '#dc2626', light: '#fef2f2', text: '#dc2626' },
  other:        { bg: '#6b7280', light: '#f9fafb', text: '#6b7280' },
};

const ICON_PATHS = {
  building: 'M3 21h18M3 7v14m18-14v14M6 11h.01M6 15h.01M6 19h.01M10 11h.01M10 15h.01M10 19h.01M14 11h.01M14 15h.01M14 19h.01M18 11h.01M18 15h.01M18 19h.01M3 7l9-4 9 4',
  medicine: 'M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 5.625h3m-3 3.75h3m-6-3.75h.008v.008H7.5v-.008zm0 3.75h.008v.008H7.5v-.008zm0 3.75h.008v.008H7.5v-.008z',
  flask: 'M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19 14.5M14.25 3.104c.251.023.501.05.75.082M5 14.5l-.94.94a1.5 1.5 0 000 2.12l.94.94m0 0l2.121 2.121M5 14.5h14m0 0l.94.94a1.5 1.5 0 010 2.12L19 18.5m0 0l-2.121 2.121',
  calendar: 'M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5',
  trophy: 'M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-4.5A3.375 3.375 0 0019.875 10.875 3.375 3.375 0 0016.5 14.25m-9 4.5V14.25m0 0A3.375 3.375 0 014.125 10.875 3.375 3.375 0 017.5 14.25M12 4.5v3.75',
  document: 'M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z',
  handshake: 'M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z',
  megaphone: 'M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 110-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38a.75.75 0 01-1.021-.268l-.011-.018a15.845 15.845 0 01-1.011-2.186m2.177-2.202c2.638-.315 5.127-1.082 7.41-2.24a.75.75 0 000-1.32 24.588 24.588 0 00-7.41-2.24',
  star: 'M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z',
};

const TimelineIcon = ({ icon, color }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d={ICON_PATHS[icon] || ICON_PATHS.star} />
  </svg>
);

export default function ArchivePage() {
  const [archives, setArchives] = useState([]);
  const [years, setYears] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ year: 'all', category: 'all', search: '' });
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/public/archives`, { params: filters.year !== 'all' ? { year: filters.year } : {} }).then(r => r.data),
      axios.get(`${API}/public/archives/years`).then(r => r.data),
    ]).then(([a, y]) => {
      setArchives(a || []);
      setYears(y || []);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const applyFilters = () => {
    setLoading(true);
    const p = {};
    if (filters.year !== 'all') p.year = filters.year;
    if (filters.category !== 'all') p.category = filters.category;
    if (filters.search) p.search = filters.search;
    axios.get(`${API}/public/archives`, { params: p }).then(r => setArchives(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(() => { applyFilters(); }, [filters.year, filters.category]);

  const openDetail = (slug) => {
    axios.get(`${API}/public/archives/${slug}`).then(r => setDetail(r.data)).catch(() => {});
  };

  // Group by year
  const grouped = {};
  archives.forEach(a => {
    if (!grouped[a.year]) grouped[a.year] = [];
    grouped[a.year].push(a);
  });
  const sortedYears = Object.keys(grouped).sort((a, b) => b - a);

  const searchTimeout = React.useRef(null);
  const handleSearch = (val) => {
    setFilters(f => ({ ...f, search: val }));
    clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(applyFilters, 400);
  };

  return (
    <div style={{ background: '#f8fafc', minHeight: '100vh' }}>
      <SEOHead page="archive" fallback={{ title: 'Archive & Timeline - IDSEA', description: 'Explore our journey, innovations, products, events, and achievements.' }} />
      <PublicNavbar />

      {/* Hero */}
      <section style={{ background: 'linear-gradient(135deg, #0c3c60 0%, #164e7e 50%, #1e7a4d 100%)', padding: '80px 24px 60px', textAlign: 'center' }}>
        <h1 style={{ fontFamily: 'Poppins, sans-serif', color: 'white', fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 800, marginBottom: '12px', letterSpacing: '-0.5px' }}>Archive & Milestones</h1>
        <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '16px', fontFamily: 'Inter, sans-serif', maxWidth: '600px', margin: '0 auto' }}>Our Journey &bull; Innovations &bull; Products &bull; Events &bull; Achievements</p>
      </section>

      {/* Filters */}
      <div style={{ maxWidth: '900px', margin: '-28px auto 0', padding: '0 24px', position: 'relative', zIndex: 10 }}>
        <div style={{ background: 'white', borderRadius: '16px', padding: '16px 20px', boxShadow: '0 8px 32px rgba(12,60,96,0.12)', display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
          <div style={{ position: 'relative', flex: 1, minWidth: '180px' }}>
            <Search size={15} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#9ca3af' }} />
            <input value={filters.search} onChange={e => handleSearch(e.target.value)} placeholder="Search archive..." data-testid="archive-search"
              style={{ width: '100%', padding: '10px 10px 10px 36px', border: '1px solid #e5e7eb', borderRadius: '10px', fontSize: '14px', fontFamily: 'Inter', outline: 'none' }} />
          </div>
          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
            {['all', ...years].map(y => (
              <button key={y} onClick={() => setFilters(f => ({ ...f, year: String(y) }))}
                data-testid={`year-${y}`}
                style={{ padding: '8px 14px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: 600, fontFamily: 'Poppins',
                  background: filters.year === String(y) ? '#0c3c60' : '#f1f5f9', color: filters.year === String(y) ? 'white' : '#4b5563', transition: 'all 0.2s'
                }}>
                {y === 'all' ? 'All Years' : y}
              </button>
            ))}
          </div>
          <select value={filters.category} onChange={e => setFilters(f => ({ ...f, category: e.target.value }))} data-testid="archive-cat-filter"
            style={{ padding: '8px 12px', border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '13px', fontFamily: 'Poppins', fontWeight: 600, background: 'white', color: '#374151' }}>
            <option value="all">All Categories</option>
            {Object.keys(CAT_THEME).map(c => <option key={c} value={c} style={{ textTransform: 'capitalize' }}>{c}</option>)}
          </select>
        </div>
      </div>

      {/* Timeline */}
      <div style={{ maxWidth: '900px', margin: '48px auto 80px', padding: '0 24px', position: 'relative' }}>
        {loading && <div style={{ textAlign: 'center', padding: '60px', color: '#9ca3af', fontSize: '15px' }}>Loading timeline...</div>}
        {!loading && archives.length === 0 && <div style={{ textAlign: 'center', padding: '80px 20px', color: '#9ca3af' }}><Calendar size={40} style={{ margin: '0 auto 16px', opacity: 0.3 }} /><p style={{ fontSize: '16px', fontFamily: 'Poppins' }}>No archive entries found</p></div>}

        {sortedYears.map(year => (
          <div key={year} style={{ position: 'relative', marginBottom: '60px' }}>
            {/* Year badge */}
            <div style={{ textAlign: 'center', marginBottom: '40px', position: 'relative', zIndex: 5 }}>
              <span style={{ display: 'inline-block', background: 'linear-gradient(135deg, #0c3c60, #1e7a4d)', color: 'white', padding: '10px 32px', borderRadius: '50px', fontFamily: 'Poppins, sans-serif', fontSize: '28px', fontWeight: 800, letterSpacing: '1px', boxShadow: '0 4px 16px rgba(12,60,96,0.3)' }} data-testid={`year-badge-${year}`}>
                {year}
              </span>
            </div>

            {/* Central line */}
            <div className="timeline-line" style={{ position: 'absolute', left: '50%', top: '80px', bottom: '0', width: '3px', background: 'linear-gradient(180deg, #0c3c60, #1e7a4d, #0c3c60)', transform: 'translateX(-50%)', borderRadius: '2px', opacity: 0.3 }} />

            {grouped[year].map((item, idx) => {
              const isLeft = idx % 2 === 0;
              const theme = CAT_THEME[item.category] || CAT_THEME.other;

              return (
                <div key={item.id} className={`timeline-item ${isLeft ? 'tl-left' : 'tl-right'}`}
                  style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '40px', position: 'relative', cursor: 'pointer', flexDirection: isLeft ? 'row' : 'row-reverse' }}
                  onClick={() => openDetail(item.slug || item.id)} data-testid={`timeline-item-${item.id}`}>

                  {/* Content card */}
                  <div className="tl-card" style={{ flex: 1, maxWidth: 'calc(50% - 40px)', background: 'white', borderRadius: '16px', padding: '24px', boxShadow: '0 2px 16px rgba(0,0,0,0.06)', border: `1px solid ${theme.bg}15`, transition: 'transform 0.25s, box-shadow 0.25s' }}
                    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = `0 12px 32px ${theme.bg}20`; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 16px rgba(0,0,0,0.06)'; }}>

                    {item.featured_image && (
                      <div style={{ marginBottom: '14px', borderRadius: '10px', overflow: 'hidden', maxHeight: '160px' }}>
                        <img src={resolveUrl(item.featured_image)} alt="" style={{ width: '100%', height: '160px', objectFit: 'cover' }} />
                      </div>
                    )}

                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
                      <span style={{ fontSize: '12px', padding: '3px 10px', borderRadius: '10px', background: theme.light, color: theme.text, fontWeight: 700, fontFamily: 'Poppins', textTransform: 'capitalize' }}>{item.category}</span>
                      <span style={{ fontSize: '11px', color: '#9ca3af', fontWeight: 600 }}>{item.date} {FULL_MONTHS[item.month - 1]} {item.year}</span>
                    </div>

                    <h3 style={{ fontFamily: 'Poppins, sans-serif', fontSize: '17px', fontWeight: 700, color: '#0c3c60', marginBottom: '8px', lineHeight: 1.35 }}>{item.heading}</h3>

                    {item.short_description && (
                      <p style={{ fontSize: '13px', color: '#6b7280', lineHeight: 1.65, marginBottom: '14px', fontFamily: 'Inter, sans-serif' }}>{item.short_description}</p>
                    )}

                    {item.buttons?.length > 0 && (
                      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                        {item.buttons.slice(0, 2).map((btn, bi) => (
                          <span key={bi} style={{ fontSize: '12px', color: theme.text, fontWeight: 600, display: 'flex', alignItems: 'center', gap: '4px' }}>
                            {btn.name} <ChevronRight size={12} />
                          </span>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Center node */}
                  <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', width: '44px', height: '44px', borderRadius: '50%', background: 'white', border: `3px solid ${theme.bg}`, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 5, boxShadow: `0 0 0 4px ${theme.bg}20` }}>
                    <TimelineIcon icon={item.icon} color={theme.bg} />
                  </div>

                  {/* Date badge on opposite side */}
                  <div style={{ flex: 1, maxWidth: 'calc(50% - 40px)', display: 'flex', alignItems: isLeft ? 'flex-start' : 'flex-end', paddingTop: '16px', flexDirection: 'column' }}>
                    <div style={{ textAlign: isLeft ? 'left' : 'right' }}>
                      <div style={{ fontFamily: 'Poppins', fontSize: '32px', fontWeight: 800, color: theme.bg, opacity: 0.15, lineHeight: 1 }}>{item.date}</div>
                      <div style={{ fontFamily: 'Poppins', fontSize: '13px', fontWeight: 700, color: theme.bg, textTransform: 'uppercase', letterSpacing: '1px' }}>{MONTHS[item.month - 1]}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {/* Detail Modal */}
      {detail && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.6)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', backdropFilter: 'blur(4px)' }} onClick={() => setDetail(null)}>
          <div style={{ background: 'white', borderRadius: '20px', maxWidth: '720px', width: '100%', maxHeight: '90vh', overflow: 'auto', position: 'relative' }} onClick={e => e.stopPropagation()} data-testid="archive-detail-modal">
            <button onClick={() => setDetail(null)} data-testid="close-archive-modal" style={{ position: 'sticky', top: '12px', float: 'right', marginRight: '12px', zIndex: 10, width: '36px', height: '36px', borderRadius: '50%', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><X size={18} /></button>

            {detail.featured_image && (
              <img src={resolveUrl(detail.featured_image)} alt="" style={{ width: '100%', maxHeight: '300px', objectFit: 'cover', borderRadius: '20px 20px 0 0' }} />
            )}

            <div style={{ padding: '32px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px', flexWrap: 'wrap' }}>
                <span style={{ fontSize: '12px', padding: '4px 12px', borderRadius: '10px', background: (CAT_THEME[detail.category] || CAT_THEME.other).light, color: (CAT_THEME[detail.category] || CAT_THEME.other).text, fontWeight: 700, fontFamily: 'Poppins', textTransform: 'capitalize' }}>{detail.category}</span>
                <span style={{ fontSize: '13px', color: '#6b7280', fontWeight: 600, fontFamily: 'Poppins' }}>{detail.date} {FULL_MONTHS[detail.month - 1]} {detail.year}</span>
              </div>

              <h1 style={{ fontFamily: 'Poppins, sans-serif', fontSize: '26px', fontWeight: 800, color: '#0c3c60', marginBottom: '20px', lineHeight: 1.3 }}>{detail.heading}</h1>

              {detail.content && (
                <div style={{ fontSize: '15px', color: '#374151', lineHeight: 1.8, fontFamily: 'Inter, sans-serif', marginBottom: '24px' }} dangerouslySetInnerHTML={{ __html: detail.content }} />
              )}

              {detail.video_url && (
                <div style={{ marginBottom: '24px', borderRadius: '12px', overflow: 'hidden', position: 'relative', paddingBottom: '56.25%' }}>
                  <iframe src={detail.video_url} title="Video" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }} allowFullScreen />
                </div>
              )}

              {detail.gallery?.length > 0 && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '8px', marginBottom: '24px' }}>
                  {detail.gallery.map((img, i) => (
                    <a key={i} href={resolveUrl(img)} target="_blank" rel="noreferrer"><img src={resolveUrl(img)} alt="" style={{ width: '100%', height: '100px', objectFit: 'cover', borderRadius: '8px' }} /></a>
                  ))}
                </div>
              )}

              {detail.attachments?.length > 0 && (
                <div style={{ marginBottom: '24px' }}>
                  <h4 style={{ fontFamily: 'Poppins', fontSize: '14px', fontWeight: 700, color: '#0c3c60', marginBottom: '10px' }}>Attachments</h4>
                  {detail.attachments.map((att, i) => (
                    <a key={i} href={resolveUrl(att.file_url)} download target="_blank" rel="noreferrer"
                      style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 14px', background: '#f8fafc', borderRadius: '10px', border: '1px solid #e5e7eb', marginBottom: '6px', textDecoration: 'none', color: '#374151', transition: 'background 0.2s' }}>
                      <Download size={15} style={{ color: '#2563eb' }} />
                      <span style={{ flex: 1, fontSize: '13px', fontWeight: 600 }}>{att.display_name || att.file_name}</span>
                      <span style={{ fontSize: '10px', color: '#9ca3af', fontWeight: 600 }}>{att.file_type}</span>
                    </a>
                  ))}
                </div>
              )}

              {detail.buttons?.length > 0 && (
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  {detail.buttons.map((btn, i) => {
                    const theme = CAT_THEME[detail.category] || CAT_THEME.other;
                    const isPrimary = btn.style === 'primary';
                    return (
                      <a key={i} href={btn.url} target={btn.new_tab ? '_blank' : '_self'} rel="noreferrer" data-testid={`archive-btn-${i}`}
                        style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '10px 22px', borderRadius: '10px', fontWeight: 700, fontFamily: 'Poppins', fontSize: '13px', textDecoration: 'none', transition: 'all 0.2s',
                          background: isPrimary ? theme.bg : 'transparent', color: isPrimary ? 'white' : theme.text,
                          border: isPrimary ? 'none' : `2px solid ${theme.bg}30`
                        }}>
                        {btn.name} {btn.new_tab && <ExternalLink size={12} />}
                      </a>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Responsive CSS */}
      <style>{`
        @media (max-width: 768px) {
          .timeline-line { left: 24px !important; }
          .timeline-item { flex-direction: column !important; align-items: flex-start !important; padding-left: 56px !important; }
          .timeline-item .tl-card { max-width: 100% !important; }
          .timeline-item > div:last-child { display: none !important; }
          .timeline-item > div[style*="position: absolute"] { left: 24px !important; top: 0 !important; width: 36px !important; height: 36px !important; }
          .timeline-item > div[style*="position: absolute"] svg { width: 16px !important; height: 16px !important; }
        }
      `}</style>

      <PublicFooter />
    </div>
  );
}
